<template>
  <ArtLibraryDialog ref="artLibraryDialogRef" @onClose="onCloseDialog" @onConfirm="onConfirmDialog" v-if="artDialogShow" :dialogType="artDialogType"/>
  <!-- <ProDialog v-if="proDialog" @onClose="hideProDialog" :parmas="currentPro" /> -->
  <div class="artImportDialog" @click="onClose">
    <div class="artImportMain" @click="((event)=>onItemClick(event))">
      <div class="back">
        <PDFStatsButton :iconFont="`icon-icon_close`" customFontSize="14px" paddingTop="0 0" paddingH="0 0" @ButtonClick="(()=> onClose())"/>
      </div>
      <div class="art-title">{{ $t("art_import_title") }}</div>
      <div class="top-operate" v-if="!isError">
        <div class="art-error" v-if="getErrorLength > 0">
          <div class="art-abnormal" >{{ $t("art_error_tips4").replace("*",`${getErrorLength}`) }}</div>
          <div class="art-folder-link" @click="toErrorPoint">{{$t("art_error_tips5")}}</div>
        </div>
          <div class="operateAll">
            <div class="left-operate">
            <div class="top-operate-title">{{ $t("art_import_left_title") }}</div>
            <el-select
              v-model="originalColumn"
              filterable
              :placeholder="$t('enterprise_management_select_value')"
              
              class="select-view"
              @change="handleOriginalChange"
            >
              <el-option
                v-for="item in columnCount"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
          <div class="center-operate" />
          <div class="right-operate">
            <div class="top-operate-title">{{ $t("art_import_right_title") }}</div>
            <el-select
              v-model="translationColumn"
              filterable
              :placeholder="$t('enterprise_management_select_value')"
              class="select-view"
              @change="handleTranslationChange"
            >
              <el-option
                v-for="item in columnCount"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </div>
      </div>
      <div class="importList" v-if="!isError">
        <DynamicScroller
          :items="excels"
          key-field="index"
          :min-item-size="50"
          v-slot="{ item, index, active}"
          :buffer="200"
          observe-dom
          ref="scroller"
        >
          <DynamicScrollerItem
            :item="item"
            :active="active"
            :key="item.index"
            :data-index="index"
            :size-dependencies="[item.leftError || artFilesMap[item.entryKey] || item.rightError]"
          >
          <!-- :class="{'set_height':item.rightError || item.leftError}" -->
          <div class="import-item" :class="{'set_height':item.rightError || item.leftError}" >
            <div class="item-top_responsive">
              <div class="fristView">
                {{ index + 1 }}
              </div>
              <div class="right_view" v-if="true">
                <el-tooltip
                    effect="dark"
                    placement="top"
                    :content="$t('art_edit')"
                    v-if="!item.isEdit"
                >
                  <i class="iconfont icon-icon_edit" v-if="!item.isEdit" @click="()=>{onEdit(index, item)}"/>
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  placement="top"
                  :content="$t('art_delete')"
                  v-if="!item.isEdit"
                >
                  <i class="iconfont icon-icon_delete" v-if="!item.isEdit" @click="()=>{onDelete(index, item)}" />
                </el-tooltip>
                
                <el-tooltip
                  effect="dark"
                  placement="top"
                  :content="$t('art_complete_edit')"
                  v-if="item.isEdit"
                >
                  <i class="iconfont icon-icon_correct"  v-if="item.isEdit" @click="()=>{onCompleteEdit(index, item)}" />
                </el-tooltip>
                <el-tooltip
                    effect="dark"
                    placement="top"
                    :content="$t('art_cancel_edit')"
                    v-if="item.isEdit"
                >
                  <i class="iconfont icon-icon_error" v-if="item.isEdit"  @click="()=>{onCancelEdit(index, item)}"/>
                </el-tooltip>
              </div>
            </div>
            <div class="import-item_body" :class="{'set_margintop':item.rightError || item.leftError}">
              <!-- 源语言 -->
              <!-- <div class="source_view"></div> -->
              <!-- 目标语言 -->
               <!-- <div class="target_view"></div> -->
               <div class="item-left ">
                  <!-- <div class="fristView">
                    {{ item.index }}
                  </div> -->
                  <div class="secondView" v-if="!operateArtMap[item.index]">
                    <div style="flex-direction: row; display: flex; align-items: center; height: 30px;width: 100%;">
                      <el-tooltip effect="dark" placement="top" :content="item.entryKey" 
                        style="max-width: 200px; word-wrap: break-word;" >
                        <div class="second-title">{{item.entryKey}}</div>
                      </el-tooltip>
                    </div>
                    <div class="errorView" v-show="item.leftError || item.rightError ">
                      <i class="iconfont icon-icon_question" v-show="item.leftError"/>
                      <div class="errorText" v-show="item.leftError">{{ item.leftError == 2 ? $t("art_error_tips1") : $t("art_error_tips2") }}</div>
                    </div>
                  </div>
                  <div class="operateInput" v-if="operateArtMap[item.index]" :key="`${item.index}`">
                    <input
                        type="text"
                        :class="`chooseImportSelectInput ${getLeftInputClass(item.index)}`"
                        :value="operateArtMap[item.index].entryKey"
                        @input="(event)=>{handleInput(event, index, item, 1)}"
                        @blur="()=>{operateArtMap[item.index].leftFocus = false}"
                        @focus="()=>{operateArtMap[item.index].leftFocus = true}"
                    />
                    <div class="errorInputView" v-show="item.leftError || item.rightError">
                      <i class="iconfont icon-icon_question" v-show="item.leftError"/>
                      <div class="errorText" v-show="item.leftError">{{ item.leftError == 2 ? $t("art_error_tips1") : $t("art_error_tips2") }}</div>
                    </div>
                  </div>
                </div>
                <div class="item-center">
                  <i class="iconfont icon-icon_to" />
                </div>
                <!-- " -->
                <div class="item-right">
                  
                  <div class="fristView" v-if="!operateArtMap[item.index]">
                    
                    <div style="flex-direction: row; display: flex; align-items: center; height: 30px; width:100%;">
                      <el-tooltip effect="dark" placement="top" :content="item.entryValue" 
                        style="max-width: 200px; word-wrap: break-word;">
                        <div class="frist-title">{{item.entryValue}}</div>
                      </el-tooltip>
                    </div>
                    <div class="errorView" v-show="item.leftError || item.rightError ">
                      <i class="iconfont icon-icon_question" v-show="item.rightError"/>
                      <div class="errorText" v-show="item.rightError">{{ $t("art_error_tips3") }}</div>
                    </div>
                  </div>
                  <div class="operateInput" v-if="operateArtMap[item.index]">
                    <input
                        type="text"
                        :class="`chooseImportSelectInput ${getRightInputClass(item.index)}`"
                        :value="operateArtMap[item.index].entryValue"
                        @input="(event)=>{handleInput(event, index, item, 2)}"
                        @blur="()=>{operateArtMap[item.index].rightFocus = false}"
                        @focus="()=>{operateArtMap[item.index].rightFocus = true}"
                    />
                    <div class="errorInputView" v-show="item.rightError || item.leftError">
                      <i class="iconfont icon-icon_question" v-show="item.rightError"/>
                      <div class="errorText" v-show="item.rightError">{{ $t("art_error_tips3") }}</div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <div class="item-line" />
          </DynamicScrollerItem>
        </DynamicScroller>
      </div>
      <div class="error-box" v-if="isError">
        <div class="error-title" style="margin-top: 50px;">{{ $t("art_error_title") }}</div> 
        <div >
          <div class="tips-title" style="margin-top: 40px;">{{ $t("art_error_tips6") }}</div>
          <div class="tips-title" style="margin-top: 10px;">{{ $t("art_error_tips7") }}</div>
        </div>
      
        <div class="download-title" style="margin-top: 10px;" @click="()=>{onDownloadFile()}" >{{ $t("art_error_tips8") }}</div>
      </div>
      <div class="import-btn">
        <!-- <div class="import-cancel">{{ $t("") }}</div> -->
        <div class="btn">
          <PDFStatsButton :title="$t(`cancel`)" :color="`#ffffff`" :textColor="'#2690E1'" customFontSize="14px" paddingTop="0 0" :borderStyle="'#2690E1 solid 1px'" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
          <div style="margin: 0 10px;" />
          <PDFStatsButton :title="$t(`save`)" :color="`#2590E1`" textColor="white" :borderStyle="'#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onSave())"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import eventBus from 'vue3-eventbus'
import useUserStore from "~/store/modules/user";
import useProStore from "~/store/modules/pro";

import {storeToRefs} from "pinia";
import {defineEmits, ref, inject} from "vue";
import Toast from "~/utils/toast";
import {useI18n} from "vue-i18n";
import {useRouter} from "vue-router";
import ArtLibraryDialog from "@/components/Translate/Art/ArtLibraryDialog.vue"
import AccountServer from "@/services/AccountServer"
import PDFStatsButton from "@/components/Button/PDFStatsButton.vue"
// import {
//   getRequestTermImportterm,
//   getRequestCheckTermName,
//   getRequestCheckTermKeyName,
//   getRequestTermImportentry,
//   getRequestTermentrylist
// } from "@/net/upload"

const { t, locale } = useI18n()
const userStore = useUserStore();
const userProStore = useProStore();
const { proConfig } = storeToRefs(userProStore);
const { userInfo, userRights} = storeToRefs(userStore);
const router = useRouter()
const route = useRoute()
const errorsMap = ref({})
const operateArtMap = ref({})
const excels = ref([])
const columnCount = ref([])
const originalColumn = ref(1)
const translationColumn = ref(2)
const artFilesMap = ref({})
const scroller = ref([])
let keysMap = {}

const artDialogShow = ref(false)
const artDialogType = ref(0)
let proDialog = ref(false)
let currentPro = ref({})
let isError = ref(false)
defineExpose({ })

const props = defineProps({
  dialogType: {
    type: Number, // 0 添加术语库 1 添加词语
  },
  file: {
    type: Object,
    default: null
  },
  parmas: {
    type: Object,
    default: {}
  },
  termInfo: {
    type: Object,
    default: {}
  }
})

let call = defineEmits(["onClose", "onConfirm"])

const getErrorLength = computed(() => {
  return Object.keys(errorsMap.value).length
})

const getLeftInputClass = (index) => {
  if (operateArtMap.value[index] && operateArtMap.value[index].leftFocus) {
    return "selectInput"
  }
  return ""
}

const getRightInputClass = (index) => {
  if (operateArtMap.value[index] && operateArtMap.value[index].rightFocus) {
    return "selectInput"
  }
  return ""
}

function onItemClick(e :Event) {
  e.stopPropagation()
}

function onClose() {
  call("onClose")
}

function handleOriginalChange(value) {
  operateArtMap.value = {}
  updateFileContent (1)
}

function handleTranslationChange(value) {
  operateArtMap.value = {}
  updateFileContent (2)
}

function onDelete(index, item) {
  excels.value.splice(index, 1)
  delete operateArtMap.value[item.index]
  delete errorsMap.value[item.index]
  if (keysMap[item.entryKey]) {
    delete keysMap[item.entryKey]
  }
}

function onEdit(index, item) {
  // operateArtMap.value[index] = item
  console.log("onEditonEdit==>", item)
  operateArtMap.value[item.index] = {...item}
  excels.value[index].isEdit = true
}

function onCompleteEdit(index, item) {
  console.log("onCompleteEdit", item, operateArtMap.value, keysMap[operateArtMap.value[item.index].entryKey])
  let entryKey = operateArtMap.value[item.index].entryKey
  let entryValue = operateArtMap.value[item.index].entryValue
  if (!entryKey || entryKey.length == 0) {
    excels.value[index].leftError = 1
    errorsMap.value[item.index] = entryKey 
    return
  }
  if (!entryValue || entryValue.length == 0) {
    excels.value[index].rightError = 1
    errorsMap.value[item.index] = entryKey
    return
  }
  if (isWhitespace(entryKey)) {
    excels.value[index].leftError = 1
    errorsMap.value[item.index] = entryKey
    return
  }
  if (isWhitespace(entryValue)) {
    excels.value[index].rightError = 1
    errorsMap.value[item.index] = entryKey
    return
  }
  let isRepeat = keysMap[entryKey]
  if (isRepeat && isRepeat != item.index) {
    excels.value[index].leftError = 2
    errorsMap.value[item.index] = entryKey
  }else {
    console.log("onCompleteEdit==22", isRepeat, isRepeat && isRepeat != item.index, operateArtMap.value[item.index], keysMap)
    
    delete keysMap[item.entryKey]
    // 不相同 并且不是同一行
    excels.value[index].entryKey = entryKey
    excels.value[index].entryValue = entryValue
    excels.value[index].isEdit = false
    excels.value[index].leftError = undefined
    delete errorsMap.value[item.index]
    delete operateArtMap.value[item.index]
    keysMap[entryKey] = item.index
  }
}

function onCancelEdit(index, item) {
  console.log("onCancelEdit", excels.value, operateArtMap.value)
  excels.value[index].isEdit = false
  delete operateArtMap.value[item.index]
  delete errorsMap.value[item.index]
  excels.value[index].leftError = undefined
  excels.value[index].rightError = undefined
}

function markDuplicates(arr) {
  // 用于统计每个字符串出现的次数
  const countMap = new Map();

  // 第一次遍历：统计每个字符串的出现次数
  for (const item of arr) {
    if (countMap.has(item.entryKey)) {
      countMap.set(item.entryKey, countMap.get(item.entryKey) + 1);
    } else {
      countMap.set(item.entryKey, 1);
    }
  }

  // 第二次遍历：标记重复的字符串
  const result = arr.map((item) => {
    return {
      index: item.index,
      value: item.entryKey,
      entryValue: item.entryValue,
      isDuplicate: countMap.get(item.entryKey) > 1, // 如果出现次数大于 1，标记为重复
    };
  });

  return result;
}

function checkKeysEqual() {
  errorsMap.value = {}
  // 检测并标记重复项
  let isEqual = false
  const markedArray = markDuplicates(excels.value);
  console.log("asdsadad", markedArray, artFilesMap.value)
  markedArray.forEach((item, index)=>{
    // 检测当前上传的excel里面有没有相同的
    if (item.isDuplicate || artFilesMap.value[item.value]) {
      excels.value[index].leftError = 2
      errorsMap.value[item.index] = item.value
      isEqual = true
    }else if (!item.value || item.value.length == 0) {
      excels.value[index].leftError = 1
      errorsMap.value[item.index] = item.value
      isEqual = true
    }else if (!item.entryValue || item.entryValue.length == 0) {
      excels.value[index].rightError = 1
      errorsMap.value[item.index] = item.value
      isEqual = true
    }else if (isWhitespace(item.value)) {
      excels.value[index].leftError = 1
      errorsMap.value[item.index] = item.value
      isEqual = true
    }else if (isWhitespace(item.entryValue)) {
      excels.value[index].rightError = 1
      errorsMap.value[item.index] = item.value
      isEqual = true
    }
    // //检测所有已上传的词语中有没有相同的
    // if (artFilesMap.value[item.value]) {
    //   excels.value[index].leftError = 2
    //   errorsMap.value[index] = item.value
    //   isEqual = true
    // }
  })
  console.log("asdsadad", errorsMap.value)
  return isEqual
}

async function onSave() {
  if (isError.value) {
    onClose()
    return
  }
  // 检测里面是否有相同的key
  if (checkKeysEqual()) {
    return
  }
  if (props.file && props.file.name && props.dialogType == 0) {
    let list = []
    excels.value.forEach((item)=>{
      let parmas = {}
      parmas["entryKey"] = item.entryKey
      parmas["entryValue"] = item.entryValue
      list.push(parmas)
    })
    let fileNames = props.file.name.split(".").reverse()
    let fileName = props.file.name
    if (fileNames.length > 1) {
      fileName = fileNames[1]
    }

    let checkNameRes = await AccountServer.getCheckTermName({termName: fileName})
    if (checkNameRes && checkNameRes.code == "1") {
      console.log("asdasdadadqwejqwe=>", checkNameRes.data)
      if (checkNameRes.data == false) {
        AccountServer.getTermImportterm({termName: fileName, list: list}).then((result) => {
          if (result.code === "1") {
            call("onConfirm", props.dialogType)
          }
        }).catch((result) => {
          if (result && result.code == "10027") {
            // 单表词条超出
            artDialogType.value = 4
            artDialogShow.value = true
          }else if (result && result.code == "10028") {
            // 总词条超出
            artDialogType.value = 5
            artDialogShow.value = true
          }else {
            Toast(result && result.message)
          }
        })
      }else {
         // 已经存在相同名字了
         artDialogType.value = 7
         artDialogShow.value = true
      }
    }
  }else if (props.file && props.file.name && props.dialogType == 1 && props.termInfo.id) {
    let list = []
    excels.value.forEach((item)=>{
      let parmas = {}
      parmas["entryKey"] = item.entryKey
      parmas["entryValue"] = item.entryValue
      list.push(parmas)
    })
    let fileNames = props.file.name.split(".").reverse()
    let fileName = props.file.name
    if (fileNames.length > 1) {
      fileName = fileNames[1]
    }
    AccountServer.getArtImportentry({termId: props.termInfo.id, list: list}).then((result) => {
      if (result.code === "1") {
        call("onConfirm", props.dialogType)
      }
    }).catch((result) => {
      if (result && result.code == "10027") {
        // 单表词条超出
        artDialogType.value = 4
        artDialogShow.value = true
      }else if (result && result.code == "10028") {
        // 总词条超出
        artDialogType.value = 5
        artDialogShow.value = true
      }else {
        Toast(result && result.message)
      }
    })
  }
}

const handleInput = (event, index, item, type) => {
  let value = event.target.value
  //输入位数限制
  if (value.length > 50) {
    value = value.slice(0, 50)
  }
  if (type == 1) {
    operateArtMap.value[item.index].entryKey = value
    if(value.length) item.leftError = false
  }else if (type == 2) {
    operateArtMap.value[item.index].entryValue = value
    if(value.length) item.rightError = false
  }
}

function toErrorPoint() {
  if (scroller.value) {
    let errorId = -1
    Object.keys(errorsMap.value).forEach((key)=>{
      if (errorId == -1) {
        errorId = Number(key)
      }
    })
    
    let errorIndex = -1
    for (let i = 0; i < excels.value.length; i++) {
      const element = excels.value[i];
      if (element.index == errorId) {
        errorIndex = i
        break
      }
    }
    console.log("toErrorPoint", errorIndex)
    if (errorIndex >= 0) {
      scroller.value.scrollToItem(errorIndex)
    }
  }
}

// type = 0 全部更新 1 更新原文 2 更新译文
function updateFileContent (type = 0) {
  let column = 0
  if (type == 0) {
    excels.value = []
  }
  errorsMap.value = {}
  keysMap = {}
  let index = 0
  console.log("updateFileContent", props.parmas)
  if (props.parmas && props.parmas.jsonList) {
    let maxlength = props.parmas.jsonList
    if (maxlength != excels.value.length) {
      excels.value = []
    }
    let tempArr = excels.value
    props.parmas.jsonList.forEach((item)=>{
      let value = item
      let originalValue = ""
      let translationValue = ""
      let columnMax = Object.keys(value).length
      if ( column == 0 && columnMax > 0 ) {
        column = columnMax
      }
      if (columnMax > originalColumn.value - 1) {
        originalValue = value[`${originalColumn.value - 1}`]
        if (originalValue && originalValue.length > 50) {
          originalValue = originalValue.slice(0, 50)
        }
      }
      if (columnMax > translationColumn.value - 1) {
        translationValue = value[`${translationColumn.value - 1}`]
        if (translationValue && translationValue.length > 50) {
          translationValue = translationValue.slice(0, 50)
        }
      }
      if (!originalValue || isWhitespace(originalValue)) {
        return
      }
      // console.log("asdadlajdadsad", type, !keysMap[originalValue], Object.keys(value).length)
      keysMap[originalValue] = index + 1
      if (type == 0) {
        // excels.value.push({index: index + 1, entryKey: originalValue, entryValue: translationValue})
        tempArr.push({index: index + 1, entryKey: originalValue, entryValue: translationValue})
      }else if (type == 1) {
        console.log("updateFileContent3333", excels.value)
        if (index < tempArr.length - 1) {
          tempArr[index].entryKey = originalValue
          tempArr[index].leftError = undefined
          tempArr[index].index = index + 1
        }else {
          tempArr.push({index: index + 1, entryKey: originalValue, entryValue: translationValue})
        }
      }else if (type == 2) {
        if (index < tempArr.length - 1) {
          tempArr[index].entryValue = translationValue
          tempArr[index].rightError = undefined
          tempArr[index].index = index + 1
        }else {
          tempArr.push({index: index + 1, entryKey: originalValue, entryValue: translationValue})
        }
      }
      index += 1
    })
    tempArr.length = index
    excels.value = tempArr
    console.log("asdadlajdadsad", excels.value)
    columnCount.value = Array.from({ length: column }, (_, index) => index + 1);
  }
}

function requestAllFileList() {
  let param = {
    pageSize: userRights.value.termMultiTbSize || 5000,
    termId: props.termInfo.id
  }
  AccountServer.getTermentrylist(param).then((data)=> {
    if (data.code == "1") {
      let list = data.list
      if (list && list.length > 0) {
        list.forEach((item)=>{
          artFilesMap.value[item.entryKey] = item
        })
      }
    }
  }).catch((error)=>{
    
  })
}

function onCloseDialog() {
  artDialogShow.value = false
}

function hideProDialog() {
  proDialog.value = false
}

function onDownloadFile() {
  let url = `https://doclingo.s3-accelerate.amazonaws.com/template/example.xlsx`
  const link = document.createElement('a');
  link.href = url;
  link.click();
}


function onConfirmDialog(dialogType, params) {
  artDialogShow.value = false
  let configKey = userStore.getCurrentCoin(locale.value)
  if (dialogType == 4 || dialogType == 5) {
    if (userInfo.value.vipLevel == 1) {
      let membersConfig = userProStore.getProConfig('svip-1month', 'svip-month', configKey)
      currentPro.value = {type: 2, currency: configKey, purchaseType: 'year', config: membersConfig}
      proDialog.value = true
    }
  }
}

function isWhitespace(str) {
    if (str && str.length > 0) {
      return /^\s*$/.test(str);
    }
    return false
}

onMounted(()=>{
  if (props.parmas && !props.parmas.isError) {
    updateFileContent()
  }
  if (props.dialogType == 1 && props.termInfo.id && !props.parmas.isError) {
    requestAllFileList()
  }
  if (props.parmas && props.parmas.isError) {
    isError.value = props.parmas.isError
  }
})

</script>

<style scoped lang="scss">
.artImportDialog {
  flex-direction: column;
  width: 100%;
  height: 100vh;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  .artImportMain {
    display: flex;
    width: 800px;
    height: 712px;
    background-color: white;
    border-radius: 8px;
    flex-direction: column;
    position: relative;
    align-items: center;
    padding: 0 20px;
    .art-title {
      font-size: 24px;
      font-weight: bold;
      color: var(--text-color);
      margin-top: 40px;
    }
    .top-operate {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-top: 30px;
      .art-error {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        .art-abnormal {
          color: #E14C25;
          font-size: 12px;
        }
        .art-folder-link {
          color: #2590E1;
          font-size: 12px;
          font-weight: bold;
          cursor: pointer;
        }
      }
      
      .operateAll {
        display: flex;
        flex-direction: row;
        .left-operate {
          display: flex;
          flex-direction: row;
          width: 47%;
          align-items: center;
        }
        .center-operate {
          width: 3%;
          display: flex;
          flex-direction: row;
          align-items: center;
        }
        .right-operate {
          display: flex;
          flex-direction: row;
          width: 47%;
          align-items: center;
        }
      }
      
      .top-operate-title {
        color: #595959;
        font-size: 12px;
      }
      .select-view{
        width: 100px;
      }
    }
    .importList {
      margin-top: 10px;
      flex: 1;
      width: 100%;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      margin-bottom: 74px;
      scrollbar-width: none;
      .dynamic-item {
        min-height: 50px;
        width: 100%;
        display: flex;
        flex-direction: column;
      }
      .import-item {
        width: 100%;
        background-color: #F5F5F5;
        display: flex;
        flex-direction: row;
        padding: 10px 0;
        position: relative;
        // height: 30px;
        .item-left {
          display: flex;
          flex-direction: row;
          width: calc(44%);
          white-space: nowrap;      /* 禁止换行 */
          overflow: hidden;         /* 超出部分隐藏 */
          text-overflow: ellipsis;  /* 超出部分显示省略号 */
          .fristView {
            width: 42px;
            color: #595959;
            font-size: 12px;
            text-align: center;
            line-height: 30px;
            height: 30px;
          }
        }
        
        // .secondView {
        //   width: calc(100% - 42px);
        //   box-sizing: border-box;
        //   display: flex;
        //   flex-direction: column;
        //   justify-content: center;
        //   .screen-lg({
        //     // margin-left: 10px;
        //   });
        //   .screen-md({
        //     // margin-left: 10px;
        //   });
        //   .screen-sm({
        //     // margin-left: 10px;
        //   });
        //   .screen-xs({
        //     // margin-left: 10px;
        //   });
        //   .second-title {
        //     color: #595959;
        //     font-size: 12px;
            

        //   }
          .secondView {
            width: calc(100% - 62px);
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .second-title {
              width:285px;
              color: #595959;
              font-size: 12px;
              white-space: nowrap;      /* 禁止换行 */
              overflow: hidden;         /* 超出部分隐藏 */
              text-overflow: ellipsis;  /* 超出部分显示省略号 */
            }
          }
          
        // }
        .operateInput{
            display: flex;
            flex-direction: column;
            //  
            width: calc(100% - 52px);
            // padding: 0px 0 0 0;
            // margin-left:10px;
            .chooseImportSelectInput {
              // width: calc(100% - 22px);
              // width: 100%;
              font-size: 12px;
              height: 30px;
              border: 1px solid #BFBFBF;
              padding: 0 0px 0 10px;/*清除自带的padding间距*/
              outline: none;/*清除input点击之后的黑色边框*/
              background-color: white;
              text-align: start;
              border-radius: 4px;
              // margin-right: 20px;
              // margin-left: 10px;
            }
            input::-webkit-input-placeholder {
              /* placeholder颜色 */
              color: #BFBFBF;
              /* placeholder字体大小 */
              font-size: 12px;
              position: relative;
            }
            .selectInput {
              border: 1px solid #2590E1;
            }
            .errorInput {
              border: 1px solid #BFBFBF;
            }
          }
        .item-center {
          display: flex;
          flex-direction: row;
          width: 36px;
          height: 100%;
          justify-content: center;
          height: 30px;
          line-height: 30px;
        }
        .item-right {
          display: flex;
          flex-direction: row;
          // align-items: center;
          // width: 285px;
          width: calc(44%);
          // justify-content: space-between;
          .fristView {
            display: flex;
            flex-direction: column;
            align-items: start;
            width: calc(100%);
            // justify-content: center;
            .frist-title {
              width: 285px;
              color: #595959;
              font-size: 12px;
              white-space: nowrap;      /* 禁止换行 */
              overflow: hidden;         /* 超出部分隐藏 */
              text-overflow: ellipsis;  /* 超出部分显示省略号 */
              line-height: 30px;
            }
          }
          .secondView {
            // margin: 17px 10px 0 10px;
            width: 62px;
            display: flex;
            flex-direction: row-reverse;
            height: 30px;
            align-items: center;
          }
          .right_secondView{
            // display: none;
            // .screen-lg({
            //   display: none;
            // });
            // .screen-md({
            //   display: none;
            // });
            // .screen-sm({
            //   display: none;
            // });
            // .screen-xs({
            //   display: none;
            // });
          }
          .operateInput{
            display: flex;
            flex-direction: column;
            justify-content: center;
            // padding: 10px 0;
            .chooseImportSelectInput {
              // width: calc(100% - 22px);
              font-size: 12px;
              height: 30px;
              border: 1px solid #BFBFBF;
              padding: 0 0px 0 10px;/*清除自带的padding间距*/
              outline: none;/*清除input点击之后的黑色边框*/
              background-color: white;
              text-align: start;
              border-radius: 4px;
            }
            input::-webkit-input-placeholder {
              /* placeholder颜色 */
              color: #BFBFBF;
              /* placeholder字体大小 */
              font-size: 12px;
              position: relative;
            }
            .selectInput {
              border: 1px solid #2590E1;
            }
            .errorInput {
              border: 1px solid #BFBFBF;
            }
          }
        }
        .icon-icon_edit {
          color: #8C8C8C;
          font-size: 16px;
          cursor: pointer;
          &:hover {
            color: #2590E1;
          }
        }
        .icon-icon_delete {
          color: #8C8C8C;
          font-size: 16px;
          cursor: pointer;
          margin-left: 10px;
          &:hover {
            color: #2590E1;
          }
        }
        .icon-icon_correct {
          color: #34A853;
          font-size: 16px;
          cursor: pointer;
          &:hover {
            opacity: 0.6;
          }
        }
        .icon-icon_error {
          color: #E14C25;
          font-size: 16px;
          cursor: pointer;
          margin-left: 10px;
          &:hover {
            opacity: 0.6;
          }
        }
        .item-top_responsive{
          // display: none;
          display: flex;
          padding: 8px 0;
          width: 100%;
          justify-content: space-between;
          // align-items: center;
          .fristView{
            margin-left:10px;
          }
          .right_view{
            margin-right:10px;
          }
        }
        .import-item_body{
          display: flex;
          flex-direction: row;
          // width: 100%;
          position: absolute;
          top:10px;
          left:8%;
          right:8%;
          padding:0 0;
        }
      }
      .set_height{
        height: 70px !important;
      }
      .set_margintop{
        // margin-top:10px !important;
      }

      .item-line {
        width: 100%;
        height: 1px;
        background-color: white;
      }
    }
    .import-btn {
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 60px;
      background-color: #FFFFFF;
      box-shadow: 0px -6px 6px 1px rgba(0,0,0,0.16);
      border-radius: 0px 0px 8px 8px;
      
      .btn {
        flex: 1;
        flex-direction: row;
        display: flex;
        margin: 10px 20px;
      }
      // .import-cancel {
      //   background: #FFFFFF;
      //   border-radius: 4px 4px 4px 4px;
      // }
      // .import-save {

      // }
    }
    .error-box {
      margin-top: 10px;
      flex: 1;
      width: 100%;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      margin-bottom: 74px;
      align-items: center;
      .error-title {
        color: #E14C25;
        font-size: 24px;
      }
      .tips-title {
        color: #595959;
        font-size: 12px;
      }
      .download-title {
        color: #2590E1;
        font-size: 12px;
        cursor: pointer;
      }
    }
    .dialogTitle{
      margin-top: 40px;
      font-size: 16px;
      font-weight: bold;
      color: var(--text-color);
    }
    .back {
      align-self: flex-end;
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 20px;
    }
    .changeName {
      display: flex;
      flex-direction: row;
      margin-top: 20px;
      width: 100%;
      // align-items: center;
      position: relative;
      .input-position {
        position: absolute;
        right: 10px;
        top: 12px;
        color: #BFBFBF;
        font-size: 14px;
      }
      .left {
        display: flex;
        flex-direction: row;
        height: 40px;
        align-items: center;
        .art-import {
          color: #E14C25;
          font-size: 14px;
        }
        .art-name-title {
          color: var(--text-color);
          font-size: 14px;
        }
      }
      
      .art-input-div {
        display: flex;
        flex-direction: column;
        flex: 1;
        justify-content:center;
        position: relative;
        .chooseSelectInput {
          font-size: 14px;
          height: 40px;
          border: 1px solid #BFBFBF;
          padding: 0 60px 0 10px;/*清除自带的padding间距*/
          outline: none;/*清除input点击之后的黑色边框*/
          background-color: transparent;
          text-align: start;
          border-radius: 4px;
        }
        input::-webkit-input-placeholder {
          /* placeholder颜色 */
          color: #BFBFBF;
          /* placeholder字体大小 */
          font-size: 14px;
          position: relative;
        }
        .redTips {
          color: #E14C25;
          font-size: 14px;
        }
      }
    }
    .bottom {
      display: flex;
      margin-top: 30px;
      margin-bottom: 30px;
      flex-direction: row;
      align-items: center;
      height: 40px;
      width: 100%;
    }
  }
}
.errorInputView {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: calc(100% - 10px);
  height: 20px;
  margin-left: 10px;
  .icon-icon_question {
    font-size: 16px;
    color: #E14C25
  }
  .errorText {
    font-size: 12px;
    color: #E14C25;
    margin-left: 5px;
  }
}

.errorView {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 20px;
  .icon-icon_question {
    font-size: 16px;
    color: #E14C25
  }
  .errorText {
    font-size: 12px;
    color: #E14C25;
    margin-left: 5px;
  }
}
</style>
<style lang="scss">
.artImportDialog input {
    font-size: 12px !important; /* 设置字体大小 */
}
.artImportDialog textarea {
    font-size: 16px !important;; /* 设置字体大小 */
}
.vue-recycle-scroller__item-wrapper{
  margin-bottom: 35px;
}
</style>
